import Scene from '../../classes/scene';
import Utils from '../../classes/utils';


export default class SceneExample extends Scene {

	constructor(args) {
		super(args);
		this.pointer = true; // mouse pointer
		this.pointerShape = ['50 -10 100 76.3 0 76.3 50 -10']; // custom mouse pointer
		this.colors = [
			this.system.palette.red,
			this.system.palette.blue,
			this.system.palette.green,
			this.system.palette.yellow,
			this.system.palette.magenta,
		];
	}

	init(data) {
		super.init(data);

		this.system.controller.reset();
		
		let f = this.system.factory;
		let sm = this.system.sceneManager;
		let pal = this.system.palette;

		// define a multi-sample sound effect pool
		this.system.audio.defineMulti('drop', ['drop1','drop2','drop3','drop4']);

		this.pointer.sprite.position.scale = 0.2;

		this.scoreText = f.text({
			x:'50%', y:'12%', scale:2.5,
			text:' ',
			color: pal.blue,
		});

		this.hiscoreText = f.text({
			x:'50%', y:'22%', scale:2.5,
			text:' ',
			color: pal.yellow,
		});

		this.btnPoints = f.button({
			x:'50%', y:'33%', scale: 1.5,
			text:'give me 10 points!',
			color: pal.green,
			onClick: () => {
				this.btnPoints.brain.disable();
				this.system.audio.playSample('gui_select', {pan:-1});
				this.addClock({
					task:(c) => {
						this.system.controller.points(1);
						this.updateText();
						this.system.audio.playSample('gui_tiny', {volume:0.5+(c*0.05), pitch:0.5+(c*0.1)});
					},
					interval:1000/20,
					instant:true,
					repeat:10
				});
				this.addClock({
					task:() => {
						this.btnPoints.brain.enable();
						this.system.audio.playSample('gui_confirm', {pan:1});
					},
					interval:550,
					repeat:1
				});
			}
		});

		f.button({
			x:83, y:'45%', scale: 1.5,
			text:'play sound',
			align:'left',
			color: pal.blue,
			onClick: () => {
				this.system.audio.playMulti('drop');
			}
		});

		this.speakerEffect = Boolean(this.system.audio.convolverEnabled);
		this.btnSpeaker = f.button({
			x:'100% -83', y:'45%', scale: 1.5,
			text:this.speakerEffect ? 'speaker fx on ^' : 'speaker fx off ^',
			color: pal.magenta,
			align: 'right',
			onClick: () => {
				if(this.speakerEffect) {
					this.system.audio.bypassConvolver();
				} else {
					this.system.audio.enableConvolver('radio');
				}
				this.speakerEffect = !this.speakerEffect;
				this.btnSpeaker.brain.updateText(this.speakerEffect ? 'speaker fx on ^' : 'speaker fx off ^');
				this.system.audio.playSample('gui_confirm');
			}
		});

		f.button({
			x:83, y:'55%', scale: 1.5,
			text:'say hello',
			align:'left',
			color: pal.blue,
			onClick: () => {
				this.system.audio.speak(
					'hello. I am V nine-tee-nine. I am a veck-tor entertainment system from PixelJam',
					{ speed:64, pitch:80, throat:122, mouth:122, singmode:false, phoenetic:false, repitch:0.5 }
				);
			}
		});

		f.button({
			x:'100% -83', y:'55%', scale: 1.5,
			text:'do some beatboxing',
			align:'right',
			color: pal.blue,
			onClick: () => {
				this.system.audio.speak(
					'UH-UH-OY-CH-UW-T-CH-SH-V-RX-IXIX-OH-UH',
					{ speed:28, pitch:48, throat:64, mouth:64, singmode:false, phoenetic:true, repitch:0.25 }
				);
			}
		});

		this.musicPlaying = false;
		this.btnMusic = f.button({
			x:'50%', y:'65%', scale: 1.5,
			text:'play some wendy carlos',
			color: pal.blue,
			onClick: () => {
				if(this.musicPlaying) {
					this.system.audio.stopMusic();
				} else {
					this.system.audio.playMusic('wendy_carlos');
				}
				this.musicPlaying = !this.musicPlaying;
				this.btnMusic.brain.updateText(this.musicPlaying ? 'stop the music' : 'play some wendy carlos');
				this.system.audio.playSample('gui_confirm');
			}
		});

		this.infoText = f.text({
			x:'50%', y:'76.5%', scale:1,
			text:'input data',
			color: pal.white,
		});
		this.infoText.sprite.alpha = 0.3;

		f.button({
			x:83, y:'88%', scale: 1.5,
			text:'physics',
			align: 'left',
			color: pal.blue,
			onClick: () => {
				sm.changeScene('scenePhysicsDemo');
				this.system.audio.stopMusic();
				this.system.audio.playSample('gui_select');
			}
		});

		f.button({
			x:'43% -3', y:'88%', scale: 1.5,
			text:'particles',
			color: pal.blue,
			onClick: () => {
				sm.changeScene('sceneParticleDemo');
				this.system.audio.stopMusic();
				this.system.audio.playSample('gui_select');
			}
		});

		f.button({
			x:'67%', y:'88%', scale: 1.5,
			text:'ui demo',
			color: pal.yellow,
			onClick: () => {
				sm.changeScene('sceneInterfaceDemo');
				this.system.audio.stopMusic();
				this.system.audio.playSample('gui_select');
			}
		});

		f.button({
			x:'100% -83', y:'88%', scale: 1.5,
			text:'font',
			align: 'right',
			color: pal.blue,
			onClick: () => {
				sm.changeScene('sceneTextDemo');
				this.system.audio.stopMusic();
				this.system.audio.playSample('gui_select');
			}
		});

		this.addClock({
			task: () => {
				this.hiscoreText.sprite.color = Utils.randomProperty(this.system.palette);
			},
			interval: 1000/10
		});

		this.updateText();
		this.uiManager.pokeFX();
	}

	update(delta, deltaNormal) {
		super.update(delta, deltaNormal);
	}

	onPointerMove(c) {
		super.onPointerMove(c); // move generic mouse pointer
		this.updateInputInfo(c);
	}

	onPointerDown(c) {
		if(!super.onPointerDown(c)) return; // stop propogation
		// c = {x,y}
		this.pointer.sprite.color = Utils.randomElement(this.colors);
		this.updateInputInfo(c);
	}
	
	updateText() {
		this.scoreText.brain.updateText('SCORE '+this.system.controller.score);
		this.hiscoreText.brain.updateText('HISCORE '+this.system.controller.hiscore);
	}

	updateInputInfo(c) {
		this.infoText.brain.updateText(`x : ${c.x.toFixed(1)}    y : ${c.y.toFixed(1)}    mouse : ${this.system.inputManager.mousePresent}`)
	}

	onPointerUp(c) {
		// c = {x,y}
	}

	onKeyDown(key) {
		console.log('Key pressed: '+key);
	}

	onKeyUp(key) {
		console.log('Key released: '+key);
	}

}